import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import Acknowledgement from './Acknowledgement'

import { getProperty } from '../../helpers/properties';
import {getConfiguration} from "../../helpers/configuration";

const copyYear = new Date().getFullYear()

const Footer = () => {
  return (
    <footer className='footer'>
      <Route exact path={getConfiguration('baseUrl') + '/'} component={Acknowledgement} />
      <Route path={getConfiguration('baseUrl') + '/week'} component={Acknowledgement} />
      <div className='footer-txt'>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
                <div className="social-links">
                  <ul>
                    <li className="twitter"><a className="utility twitterUrl" href="https://twitter.com/victoriauninews"><span className="sr-only">Twitter</span></a></li>
                    <li className="facebook"><a className="utility facebookUrl" href="https://www.facebook.com/victoria.university"><span className="sr-only">Facebook</span></a></li>
                    <li className="youtube"><a className="utility youtubeUrl" href="https://www.youtube.com/user/VictoriaUniversity"><span className="sr-only">Youtube</span></a></li>
                    <li className="instagram"><a className="utility instagramUrl" href="https://www.instagram.com/victoriauniversity/"><span className="sr-only">Instagram</span></a></li>
                    <li className="linkedin"><a className="utility linkedinUrl" href="https://www.linkedin.com/school/victoria-university/"><span className="sr-only">Linkedin</span></a></li>
                    <li className="google"><a className="utility googlePlusUrl" href="https://plus.google.com/+victoriauniversity"><span className="sr-only">Google+</span></a></li>
                  </ul>
                </div>
                <div className='footer-links'>
                  <ul>
                    <li><a className="utility privacy" href='https://www.vu.edu.au/privacy'>Privacy</a></li>
                    <li><a className="utility legal" href='https://www.vu.edu.au/legal'>Legal</a></li>
                    <li><a className="utility copyright" href='https://www.vu.edu.au/copyright-notice'>Copyright notice</a></li>
                    <li><a className="utilty registation" href='https://www.vu.edu.au/about-vu/administration-governance/provider-registration'>Provider registration</a></li>
                    <li><a className="utilty accessiblity" href='https://www.vu.edu.au/about-vu/accessibility-of-our-website'>Accessibility information</a></li>
                    <li><a className="utilty feedback" href='https://www.vu.edu.au/contact-us/feedback'>Feedback</a></li>
                    <li><a className="utilty faq" href='https://askvu.vu.edu.au/'>FAQ (ASKVU)</a></li>
                  </ul>
                  <p className='copyright-txt'>Copyright © {copyYear}. Victoria University CRICOS Provider No. 00124K (Melbourne) and CRICOS Provider No. 02475D (Sydney). RTO Code: 3113.</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default withRouter(Footer)
